module.exports = __webpack_public_path__ + "img/homenocl.584da3a1.svg";